import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import { usePromptDialog, useUIStore } from '@/store';

export const PromptDialog: React.FC = () => {
  const { isOpen, options } = usePromptDialog();
  const closePrompt = useUIStore((state) => state.closePrompt);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (isOpen) setValue(options?.defaultValue ?? '');
  }, [isOpen, options?.defaultValue]);

  if (!options) return null;

  const handleCancel = () => closePrompt(null);

  const handleConfirm = () => closePrompt(value.trim() || null);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleConfirm();
    if (e.key === 'Escape') handleCancel();
  };

  return (
    <Dialog open={isOpen} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{options.title}</DialogTitle>
      <DialogContent sx={{ pt: '12px !important' }}>
        <TextField
          autoFocus
          fullWidth
          size="small"
          label={options.label}
          placeholder={options.placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="outlined" size="small">
          {options.cancelText ?? 'Cancel'}
        </Button>
        <Button onClick={handleConfirm} variant="contained" size="small" autoFocus>
          {options.confirmText ?? 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromptDialog;
